import { c as _c } from "react/compiler-runtime";
import { SearchInput } from '@/components/inputs';
import { addPrefixToDataParams } from '@/utils/string';
import React, { useEffect, useState } from 'react';
import { Form, Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FIELD_FULLTEXT, SearchFormValuesGCSS } from './hooks/useGcssSearch';
import { mergeClasses } from '@/utils/style';
import { addSearchParams } from '@/utils/fetcher';
import { LINKS } from '@/constants/links';
import { useRouter } from 'next/router';
import { isString } from '@/utils/types';
import { FormApi, createForm } from 'final-form';
type SearchForm = FormApi<SearchFormValuesGCSS, Partial<SearchFormValuesGCSS>>;
type Props = {
  className?: string;
  onSubmit?: () => void;
};
const useInitialSearchParams = () => {
  const $ = _c(4);
  const [initialSearchParams, setInitialSearchParams] = useState("");
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== initialSearchParams || $[1] !== router.query) {
    t0 = () => {
      if (initialSearchParams === "" && isString(router.query.search)) {
        setInitialSearchParams(router.query.search);
      }
    };
    t1 = [initialSearchParams, router.query];
    $[0] = initialSearchParams;
    $[1] = router.query;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return initialSearchParams;
};
export function Search(props) {
  const $ = _c(10);
  const {
    t
  } = useTranslation("gcss");
  const router = useRouter();
  const initialSearch = useInitialSearchParams();
  const {
    className
  } = props;
  let t0;
  if ($[0] !== props || $[1] !== router) {
    t0 = () => createForm({
      onSubmit: async values => {
        props.onSubmit?.();
        await router.push(addSearchParams(LINKS().gcssHomepageSearch, {
          search: values[FIELD_FULLTEXT]
        }));
        return Promise.resolve(values);
      }
    });
    $[0] = props;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [searchForm] = useState(t0);
  let t1;
  if ($[3] !== className || $[4] !== initialSearch || $[5] !== t) {
    t1 = t2 => {
      const {
        form,
        handleSubmit
      } = t2;
      return <form onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "gcssSearch",
        testId: "gcssSearch",
        prefix: "form"
      })} className={mergeClasses("grid grid-cols-1 lg:rounded-2xl lg:bg-white lg:px-4 lg:py-6", className)}><Field name={FIELD_FULLTEXT} initialValue={initialSearch}>{fieldRenderProps => <SearchInput {...fieldRenderProps} label={t("form.searchLabel")} hideLabel={true} onClean={() => {
            form.change(FIELD_FULLTEXT, undefined);
            form.submit();
          }} />}</Field></form>;
    };
    $[3] = className;
    $[4] = initialSearch;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== searchForm || $[8] !== t1) {
    t2 = <Form onSubmit={searchForm.submit} form={searchForm}>{t1}</Form>;
    $[7] = searchForm;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}